import { render, staticRenderFns } from "./register-media-planning.vue?vue&type=template&id=0c019570&scoped=true"
import script from "./register-media-planning.vue?vue&type=script&lang=js"
export * from "./register-media-planning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c019570",
  null
  
)

export default component.exports